<div class="header">
  <span class="headerText">Survey Maintenance</span>
  @if (!currentSurveyQuestion && !currentNonDeletableQuestion) {
  <div style="float:right">
    <div>
      <p-button type="button" (click)="addNew()">Add New</p-button>
    </div>
  </div>
  }
</div>

@if (currentSurveyQuestion) {
<form id="surveyQuestionForm" #surveyQuestionForm="ngForm">
  <div class="row">
    <div class="col-11">
      <h6>Question</h6>
      <textarea pInputTextarea #questionInput name="question" [(ngModel)]="currentSurveyQuestion.question"
        required></textarea>
    </div>
    <div class="col-1">
      <h6>&nbsp;</h6>
      <div>
        <p-radiobutton name="isYesNoGroup" [value]="true" [(ngModel)]="currentSurveyQuestion.isYesNo" inputId="yesNo">
        </p-radiobutton>
        <label for="yesNo">Yes/No</label>
      </div>
      <div>
        <p-radiobutton name="isYesNoGroup" [value]="false" [(ngModel)]="currentSurveyQuestion.isYesNo" inputId="comment">
        </p-radiobutton>
        <label for="comment">Comment</label>
      </div>
    </div>
  </div>
  <div class="row-container" style="flex-direction: row-reverse; justify-content: space-between;">
    <div>
      <p-button type="button" (click)="deleteCurrent()" severity="danger" [disabled]="!currentSurveyQuestion.id"
        label="Delete">
      </p-button>
      <p-button type="button" severity="warn" (click)="cancel()" label="Cancel">
      </p-button>
      <p-button type="submit" severity="success" (click)="save(surveyQuestionForm, currentSurveyQuestion)" label="Save">
      </p-button>
    </div>
    @if (surveyQuestionForm.invalid && surveyQuestionForm.submitted) {
    <div>
      <div class="alert alert-danger" role="alert">
        There are errors on this page. Please correct the errors and resubmit.
      </div>
    </div>
    }
  </div>
</form>
}
@if (currentNonDeletableQuestion) {
<form id="surveyNonDeleteQuestionForm" #surveyNonDeleteQuestionForm="ngForm">
  <div class="row">
    <div class="col-12">
      <h6>Question</h6>
      <textarea pInputTextarea #indelibleQuestionInput name="nonDeletableQuestion"
        [(ngModel)]="currentNonDeletableQuestion.question" required></textarea>
    </div>
  </div>
  <div class="row">
    @if (surveyNonDeleteQuestionForm.invalid && surveyNonDeleteQuestionForm.submitted) {
    <div class="col-12">
      <div class="alert alert-danger" role="alert">
        There are errors on this page. Please correct the errors and resubmit.
      </div>
    </div>
    }
    <div class="col-12">
      <p-button type="submit" severity="success"
        (click)="save(surveyNonDeleteQuestionForm, currentNonDeletableQuestion)" label="Save">
      </p-button>
      <p-button type="button" severity="warn" (click)="cancelNonDelete()" label="Cancel">
      </p-button>
    </div>
  </div>
</form>
}
@if (surveyQuestions && surveyQuestions.length > 0) {
<div class="p-grid">
  <div class="col-12">
    <div>
      <p-checkbox [binary]="true" name="displayTopQuestionsCB" [(ngModel)]="displayTopQuestions" (click)="toggleDisplaySatisfied()"></p-checkbox>
      <label for="displayTopQuestionsCB">Check to display the following mandatory questions on the outgoing surveys</label>
    </div>
  </div>
  <div class="col-12">
    <div class="question-list">
      @for (question of hideableSurveyQuestions; track question) {
      <div class="question-box">
        <span style="display: inline-block; padding-left: .5em;">
          {{question.question}}
          <b>&nbsp;- {{question.isYesNo ? 'Yes/No' : 'Comment'}}</b>
        </span>
        <span style="display: inline-block;">
          <p-button type="button" icon="pi pi-pencil" (click)="editNonDelete(question)" severity="secondary">
          </p-button>
        </span>
      </div>
      }
    </div>
  </div>
  <div class="col-12">
    <!-- <span class="noteText">Note: If the first question on the survey is a Yes/No question, its results will be displayed
        in the
      survey results list.</span>
      <span class="noteText">For consistency, we recommend the first question is along the lines of "Was our
      service satisfactory?"</span> -->
    <br>
    <h5>Additional Questions</h5>
  </div>
  <div class="col-12">
    <div cdkDropList class="question-list" (cdkDropListDropped)="drop($event)">
      @for (question of deletableSurveyQuestions; track question) {
      <div class="question-box cursor-move" cdkDrag>
        <span style="display: inline-block;">
          <i class="pi pi-sort" style="margin-right: .5em;"></i>
          {{question.question}}
          <b>&nbsp;- {{question.isYesNo ? 'Yes/No' : 'Comment'}}</b>
        </span>
        <span style="display: inline-block;">
          <p-button type="button" icon="pi pi-pencil" (click)="edit(question)" severity="secondary">
          </p-button>
          <p-button type="button" icon="pi pi-trash" (click)="deleteFromList(question)" severity="danger">
          </p-button>
        </span>
      </div>
      }
    </div>
  </div>
</div>
}